var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgBilligShowmore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 4.5501C14.0217 4.15613 12.9754 3.95872 11.9207 3.96914C10.8661 3.97956 9.82384 4.19761 8.85347 4.61083C7.8831 5.02405 7.00362 5.62435 6.26524 6.37746C5.52687 7.13058 4.94406 8.02175 4.5501 9.00009C3.75445 10.976 3.77629 13.187 4.61083 15.1467C5.44537 17.1065 7.02423 18.6544 9.00009 19.4501M9.00009 15.0001V20.0001H4.00009M18.3711 7.16016V7.17016M13 19.9399V19.9499M16.8398 18.3701V18.3801M19.3711 15.1001V15.1101M19.9414 11V11.01",
    stroke: "#58F2A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilligShowmore);
export default __webpack_public_path__ + "static/media/billig-showmore.ab3868fdd93c910eae1a2c5c93a0a74e.svg";
export { ForwardRef as ReactComponent };